<template>
  <div
    ref="menu"
    class="menu-wrapper"
  >
    <div
      ref="buttonContainer"
      class="menu-button-container"
      @click="triggerClick"
    >
      <slot
        v-if="$slots['menu-button']"
        name="menu-button"
        :toggleMenu="(e) => toggleMenu(e)"
      />
      <button
        v-else
        ref="button"
        class="menu-wrapper-button"
        :aria-expanded="isOpen.toString()"
        aria-haspopup="true"
        :aria-controls="id"
        @click="toggleMenu"
      >
        <slot name="menu-button-text" />
      </button>
    </div>
    <teleport to="body">
      <ul
        v-if="isOpen"
        :id="id"
        ref="list"
        class="menu-wrapper-menu"
        :class="classRoot"
        role="menu"
        :style="{
          left: left,
          right: right,
          top: top,
          bottom: bottom,
          maxHeight: maxHeight + 'px',
          overflow: 'auto',
          width: customWidth ? customWidth + 'px' : 'unset'
        }"
        @close_menu="closeHandler()"
      >
        <slot
          name="menu-content"
          :closeHandler="closeHandler"
        />
      </ul>
    </teleport>
  </div>
</template>

<script>
import componentUtil from '@/commons/componentUtil'

export default {
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    hideInContent: {
      default: true,
      type: Boolean,
    },
    maxHeight: {
      default: null,
      type: Number,
    },
    classRoot: {
      default: '',
      type: String,
    },
    position: {
      default: null,
      type: Object,
    },
    customWidth: {
      default: 0,
      type: Number,
    },
  },

  data: function () {
    return {
      isOpen: false,
      id: null,
      left: 'unset',
      right: 'unset',
      top: 0,
      bottom: 'unset',
    }
  },
  watch: {
    isOpen (newVal, oldVal) {
      if (newVal) {
        // Thực hiện gán sự kiện click outside
        document.querySelector('body').click()
        setTimeout(() => {
          document.addEventListener('keydown', this.documentKeydown)
          document.addEventListener('click', this.documentClick)
        }, 0)

        this.top = '0px'
        this.left = '0px'

        this.$nextTick(() => {
          const position = componentUtil.getPosition(
            this.$refs.buttonContainer,
            this.$refs.list,
            this.position
          )

          this.top = position.top + 'px'
          this.left = position.left + 'px'
        })
      } else {
        this.$emit('closeMenuWrapper')
        document.removeEventListener('keydown', this.documentKeydown)
        document.removeEventListener('click', this.documentClick)
      }
    },
  },
  mounted () {
    this.id = Math.random().toString(36).substring(2, 15)
  },
  unmounted () {
    document.removeEventListener('keydown', this.documentKeydown)
    document.removeEventListener('click', this.documentClick)
  },
  beforeUnmount () {
    const el = this.$refs.list
    if (el) {
      el.remove()
    }
  },
  methods: {
    documentKeydown (e) {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeHandler()
      }
    },
    isDispose (target) {
      const el = this.$refs.list
      // Các container sẽ ko dispose cell
      const classes = ['.calendar-container.datepicker']
      const dispose =
        classes.findIndex((className) => {
          if (
            target.closest &&
            (target.closest(className) || target.className.contains(className))
          ) {
            return true
          }
          return false
        }) === -1

      if (dispose) {
        if (el !== target && !el.contains(target)) {
          return true
        }
      }
    },
    documentClick (e) {
      // const el = this.$refs.list
      const target = e.target

      if (this.hideInContent) {
        this.closeHandler()
        return
      }

      if (this.isDispose(target)) {
        this.closeHandler()
      }
    },
    toggleMenu (e) {
      e.stopPropagation()

      if (!this.disabled) {
        this.$emit('click', !this.isOpen)
        this.isOpen = !this.isOpen

        // Add class đánh dấu active
        if (this.isOpen) {
          this.$el.classList.add('active')
        } else {
          this.$el.classList.remove('active')
        }
      }
    },
    closeHandler () {
      this.isOpen = false

      // remove
      this.$el.classList.remove('active')
    },
    /**
     * Hàm thực thi click khi chỉ có 1 button trong buttonContainer
     */
    triggerClick () {
      const buttons = this.$refs.buttonContainer.querySelectorAll('button')
      if (buttons.length === 1) {
        buttons[0].click()
      }
    },
  },
}
</script>

<style lang="scss">

.menu-wrapper-button {
  background-color: transparent;
  border: 1px solid #555;
  cursor: pointer;
  font-size: inherit;
  display: inline-block;
  border-radius: 3px;
  font-weight: $font-weight-bold;
  line-height: 20px;
  padding: 0 5px;
  text-align: center;
  white-space: nowrap;
  margin: 0 0 0 4px;
}

.menu-wrapper-button:focus {
  outline: 0;
  color: #236ca4;
  border-color: #236ca4;
  box-shadow: 0 0 3px 2px #236ca4;
}

.menu-wrapper-menu {
  list-style: none;
  margin: 0;
  padding: 4px;
  animation: slide-down 0.2s ease;
  position: absolute;
  z-index: 9999;
  background-color: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
  min-width: 136px;
}

.menu-wrapper-item {
  outline: none;
  color: inherit;
  text-decoration: none;
  line-height: $combo-box__height;
  height: $combo-box__height;
  cursor: pointer;
  padding: 0 16px;
  display: block;
  transition: all 0.7s ease;
}

.menu-wrapper-item:hover {
  outline: 0;
  background-color: $menu-wrapper__hv;
  border-radius: 2px;
  color: $color-primary;
  transition: all 0.2s ease;
  .menu-item-ic {
    &.ic-filter- {
      &contain:before {
        background-position: -432px -240px;
      }
      &equal:before {
        background-position: -359px -288px;
      }
      &not-equal:before {
        background-position: -335px -288px;
      }
      &not-contain:before {
        background-position: -311px -336px;
      }
      &greater-than:before {
        background-position: -263px -288px;
      }
      &greater-than-or-eq:before {
        background-position: -312px -288px;
      }
      &less-than:before {
        background-position: -240px -288px;
      }
      &less-than-or-eq:before {
        background-position: -289px -288px;
      }
      &start-with:before {
        background-position: -431px -288px;
      }
      &ends-with:before {
        background-position: -457px -288px;
      }
      &null:before {
        background-position: -384px -288px;
      }
      &not-null:before {
        background-position: -408px -288px;
      }
      &remove:before {
        background-position: -192px -288px;
      }
    }
  }
}

@keyframes slide-down {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
